// extracted by mini-css-extract-plugin
export default {"orders":"Orders_orders__ivi3F","orders__left":"Orders_orders__left__eyOZ0","orders__right":"Orders_orders__right__M6orJ"};